import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import {Http, unwrapDynamic} from 'common'


export class EmailToken extends React.Component {
    static contextTypes = {
        messenger: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired
    }

    componentWillMount() {
        const {path, onSubmit} = this.props
        const {router, messenger} = this.context
        const location = router.route.location || {}
        const {email, confirm, token} = qs.parse(location.search)

        if (token && confirm && email) {
            if (confirm.includes('enrich')) { return }

            const url = unwrapDynamic(path, {email, confirm})

            const data = {
                'login': {
                  'login': email,
                  'loginType': 'email'
                },
                'token': token
            }

            Http.POST(url, data, (resp, status) => {
                const {type} = this.props
                const messageCode = (status == null) ? 'Success' : resp.type
                messenger.publish(messageCode, 'Confirm', type)
                onSubmit && onSubmit(data, status, location.search)
            })
        }
    }

    render() {
        return (<span></span>)
    }
}
